<template>
  <div class="chat-upload">
    <el-dialog v-model="dialogVisible" :title="`发送给: ${agentName}`" width="800">
      <div class="chat-upload__content">
        <!-- 图片 -->
        <div v-if="[3, 6].includes(fileInfo.type)">
          <div class="flex flex-center">
            <el-image class="chat-upload__img" v-if="fileInfo.type === 3" :src="fileInfo.file.url" fit="contain" />
            <video class="chat-upload__video" v-if="fileInfo.type === 6" :src="fileInfo.file.url" controls></video>
          </div>
          <div class="chat-upload__name">{{ fileInfo.file.name }}</div>
          <div class="chat-upload__size">{{ fileSizeText(fileInfo.file.size) }}</div>
        </div>
        <!-- 文件 -->
        <div class="flex" v-if="fileInfo.type === 4">
          <img class="chat-upload__file-icon" :src="getIcon(fileInfo.file.suffix)" alt="" />
          <div>
            <div class="chat-upload__name">{{ fileInfo.file.name }}</div>
            <div class="chat-upload__size">{{ fileSizeText(fileInfo.file.size) }}</div>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSend">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import pdfimg from '@/assets/images/pdf.png'
import pptimg from '@/assets/images/ppt.png'
import txtimg from '@/assets/images/txt.png'
import xlsimg from '@/assets/images/xls.png'
import docimg from '@/assets/images/doc.png'
import { fileSizeText } from '@/utils/index'
import { computed, defineEmits, defineExpose, getCurrentInstance, ref, defineProps } from "vue"
const props = defineProps({
  agentInfo: { type: Object, default: () => {} }
})
const emit = defineEmits(['send'])
const dialogVisible = ref(false);
const { proxy } = getCurrentInstance()
const fileInfo = ref({})
const init = (data) => {
  dialogVisible.value = true
  fileInfo.value = data
};

const agentName = computed(() => {
  return props.agentInfo.agentName || '未知'
})

const handleSend = () => {
  handleCancel()
  emit('send', fileInfo.value)
}
const handleCancel = () => {
  dialogVisible.value = false
};
const getIcon = (suffix) => {
  if ('pdf'.includes(suffix)) {
    return pdfimg
  } else if ('ppt,pptx'.includes(suffix)) {
    return pptimg
  } else if ('txt'.includes(suffix)) {
    return txtimg
  } else if ('xls,xlsx'.includes(suffix)) {
    return xlsimg
  } else if ('doc,docx'.includes(suffix)) {
    return docimg
  }
}
defineExpose({
  init
})

</script>
<style lang="less" scoped>
.chat-upload {
  &__name {
    font-size: 16px;
    color: #444444;
    line-height: 1.5;
  }
  &__size {
    font-size: 14px;
    color: #666666;
  }
  &__img {
    width: 100%;
    max-height: 300px;
    margin-bottom: 12px;
    :deep(.el-image__error) {
      height: 150px;
    }
  }
  &__video {
    width: 100%;
    max-height: 350px;
    margin-bottom: 12px;
  }
  &__file-icon {
    width: 48px;
    height: 48px;
    margin-right: 6px;
  }
}
</style>
